const datapresetcolor =[
{
    'id':'1',
    'trap':'#4766FF',
    'textcolor':'#FAFAFA',
    'subtitlecolor':'#C8FF00',
    'titlesize':'24',
    'subtitlesize':'14',
    'boxtitlesize':'80'
},
{
    'id':'2',
    'trap':'#C43B3B',
    'textcolor':'#FAFAFA',
    'subtitlecolor':'#FFC800',
    'titlesize':'24',
    'subtitlesize':'14',
    'boxtitlesize':'80'
},
{
    'id':'3',
    'trap':'#FF7B00',
    'textcolor':'#FAFAFA',
    'subtitlecolor':'#000000',
    'titlesize':'24',
    'subtitlesize':'14',
    'boxtitlesize':'80'
},
{
    'id':'4',
    'trap':'#7782B6',
    'textcolor':'#000000',
    'subtitlecolor':'#FFFFFF',
    'titlesize':'24',
    'subtitlesize':'14',
    'boxtitlesize':'80'
},
{
    'id':'5',
    'trap':'#007BFF',
    'textcolor':'#FAFAFA',
    'subtitlecolor':'#000000',
    'titlesize':'24',
    'subtitlesize':'14',
    'boxtitlesize':'80'
},
{
    'id':'7',
    'trap':'#E0FFEE',
    'textcolor':'#000000',
    'subtitlecolor':'#23A300',
    'titlesize':'24',
    'subtitlesize':'14',
    'boxtitlesize':'80'
},
]

export default datapresetcolor;